import { contactReducer, ContactState, initialContactState } from './contact';
import {
  userFormAnswerReducer,
  UserFormAnswerState,
  initialUserFormAnswerState,
} from './userFormAnswer';
import {
  userFormQuestionReducer,
  UserFormQuestionState,
  initialUserFormQuestionState,
} from './userFormQuestion';

export * from './contact';
export * from './userFormAnswer';
export * from './userFormQuestion';

import { combineReducers } from 'redux';

export type MiscState = {
  contact: ContactState;
  userFormAnswer: UserFormAnswerState;
  userFormQuestion: UserFormQuestionState;
};

export const initialMiscState: MiscState = {
  contact: initialContactState,
  userFormAnswer: initialUserFormAnswerState,
  userFormQuestion: initialUserFormQuestionState,
};

export const miscReducers = combineReducers({
  contact: contactReducer,
  userFormAnswer: userFormAnswerReducer,
  userFormQuestion: userFormQuestionReducer,
});
